/* VIVA Cosmética · Tema Shopify — interações (sem dependências) */
(function () {
  "use strict";

  /* ---------- Menu móvel ---------- */
  var menuBotao = document.getElementById("menuBotao");
  var menu = document.getElementById("menuLigacoes");
  if (menuBotao && menu) {
    menuBotao.addEventListener("click", function () {
      var aberto = menu.classList.toggle("aberto");
      menuBotao.setAttribute("aria-expanded", String(aberto));
      menuBotao.setAttribute("aria-label", aberto ? "Fechar menu" : "Abrir menu");
    });
  }

  /* ---------- Slider deslizante ---------- */
  document.querySelectorAll("[data-slider]").forEach(function (slider) {
    var slides = slider.querySelectorAll(".slide");
    if (slides.length < 2) return;
    var pontos = slider.querySelectorAll(".slider-ponto");
    var atual = 0;
    var temporizador = null;
    var autoplay = slider.dataset.autoplay === "true";
    var velocidade = (parseInt(slider.dataset.velocidade, 10) || 6) * 1000;

    function ir(indice) {
      atual = ((indice % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var ativo = i === atual;
        slide.classList.toggle("slide--ativo", ativo);
        slide.setAttribute("aria-hidden", String(!ativo));
        if ("inert" in slide) slide.inert = !ativo;
      });
      pontos.forEach(function (ponto, i) {
        ponto.classList.toggle("slider-ponto--ativo", i === atual);
      });
    }

    function parar() {
      if (temporizador) { clearInterval(temporizador); temporizador = null; }
    }

    function arrancar() {
      parar();
      if (!autoplay) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      temporizador = setInterval(function () { ir(atual + 1); }, velocidade);
    }

    var anterior = slider.querySelector("[data-slider-anterior]");
    var seguinte = slider.querySelector("[data-slider-seguinte]");
    if (anterior) anterior.addEventListener("click", function () { ir(atual - 1); arrancar(); });
    if (seguinte) seguinte.addEventListener("click", function () { ir(atual + 1); arrancar(); });
    pontos.forEach(function (ponto, i) {
      ponto.addEventListener("click", function () { ir(i); arrancar(); });
    });
    slider.addEventListener("mouseenter", parar);
    slider.addEventListener("mouseleave", arrancar);
    slider.addEventListener("focusin", parar);
    slider.addEventListener("focusout", arrancar);

    ir(0);
    arrancar();
  });

  /* ---------- Separadores (faixas de pílulas com setas adaptativas) ---------- */
  document.querySelectorAll(".separador").forEach(function (separador) {
    var fila = separador.querySelector(".separador-fila");
    var esq = separador.querySelector("[data-separador-esq]");
    var dir = separador.querySelector("[data-separador-dir]");
    if (!fila || !esq || !dir) return;

    function atualizar() {
      var transborda = fila.scrollWidth > fila.clientWidth + 4;
      esq.hidden = !transborda;
      dir.hidden = !transborda;
    }
    esq.addEventListener("click", function () {
      fila.scrollBy({ left: -fila.clientWidth * 0.7, behavior: "smooth" });
    });
    dir.addEventListener("click", function () {
      fila.scrollBy({ left: fila.clientWidth * 0.7, behavior: "smooth" });
    });
    window.addEventListener("resize", atualizar);
    atualizar();
  });

  /* ---------- Montras (carrosséis de produtos) ---------- */
  document.querySelectorAll("[data-montra-esq]").forEach(function (botao) {
    botao.addEventListener("click", function () {
      var fila = document.getElementById(botao.dataset.montraEsq);
      if (fila) fila.scrollBy({ left: -fila.clientWidth * 0.8, behavior: "smooth" });
    });
  });
  document.querySelectorAll("[data-montra-dir]").forEach(function (botao) {
    botao.addEventListener("click", function () {
      var fila = document.getElementById(botao.dataset.montraDir);
      if (fila) fila.scrollBy({ left: fila.clientWidth * 0.8, behavior: "smooth" });
    });
  });

  /* ---------- Ordenação da coleção ---------- */
  document.querySelectorAll("[data-ordenar-colecao]").forEach(function (select) {
    select.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  });
})();

/* ---------- Dinâmica: revelação ao scroll, cabeçalho compacto, voltar ao topo ---------- */
(function () {
  "use strict";
  var reduzido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!reduzido && "IntersectionObserver" in window) {
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add("revelado");
          observador.unobserve(entrada.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px" });

    function aplicar(seletor, passo) {
      var indicePorPai = new Map();
      document.querySelectorAll(seletor).forEach(function (el) {
        var pai = el.parentElement;
        var i = indicePorPai.get(pai) || 0;
        indicePorPai.set(pai, i + 1);
        el.classList.add("revelar");
        el.style.setProperty("--atraso", Math.min(i, 11) * passo + "ms");
        observador.observe(el);
      });
    }
    aplicar(".widgets li", 45);
    aplicar(".separador-pilula", 35);
    aplicar(".montra-cabecalho", 0);
    aplicar(".montra-fila .produto-cartao", 55);
    aplicar(".produtos-grelha .produto-cartao", 45);
    aplicar(".marca-miniatura", 45);
    aplicar(".blogue-cartao", 90);

    setTimeout(function () {
      document.querySelectorAll(".revelar:not(.revelado)").forEach(function (el) {
        var caixa = el.getBoundingClientRect();
        if (caixa.top < window.innerHeight && caixa.bottom > 0) {
          el.classList.add("revelado");
        }
      });
    }, 2500);
  }

  var voltarTopo = document.createElement("button");
  voltarTopo.type = "button";
  voltarTopo.className = "voltar-topo";
  voltarTopo.setAttribute("aria-label", "Voltar ao topo");
  voltarTopo.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  voltarTopo.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: reduzido ? "auto" : "smooth" });
  });
  document.body.appendChild(voltarTopo);

  var cabecalho = document.querySelector(".cabecalho");
  var aguarda = false;
  function aoRolar() {
    if (aguarda) return;
    aguarda = true;
    requestAnimationFrame(function () {
      aguarda = false;
      var y = window.scrollY;
      if (cabecalho) cabecalho.classList.toggle("cabecalho--compacto", y > 40);
      voltarTopo.classList.toggle("voltar-topo--visivel", y > 600);
    });
  }
  window.addEventListener("scroll", aoRolar, { passive: true });
  aoRolar();
})();

/* ---------- Sugestões do cesto (recomendações Shopify) ---------- */
(function () {
  "use strict";
  var contentor = document.querySelector("[data-recomendacoes-cesto]");
  if (!contentor || !contentor.dataset.url) return;

  function injetar(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var novo = doc.querySelector("[data-recomendacoes-cesto]");
    if (novo && novo.querySelector(".produto-cartao")) {
      contentor.innerHTML = novo.innerHTML;
      return true;
    }
    return false;
  }

  fetch(contentor.dataset.url + "&intent=complementary")
    .then(function (r) { return r.text(); })
    .then(function (html) {
      if (injetar(html)) return null;
      // Sem lista de complementares definida — usar produtos relacionados.
      return fetch(contentor.dataset.url + "&intent=related")
        .then(function (r) { return r.text(); })
        .then(injetar);
    })
    .catch(function () { /* sem sugestões — o cesto funciona na mesma */ });
})();
